import brands from './brands';
import carts from './carts';
import players from './players';
import products from './products';
import videos from './videos';
import tracking from './tracking';
import launchLinkParams from './launchLinkParams';
import amazonSalesSignups from './amazonSales';
import discover from './discover';
import launchMasterList from './launchMasterList';
import recentLaunchOptions from './recentLaunchOptions';
import i18n from './i18n';

export default {
  ...brands,
  ...carts,
  ...players,
  ...products,
  ...videos,
  ...tracking,
  ...launchLinkParams,
  ...amazonSalesSignups,
  ...discover,
  ...launchMasterList,
  ...recentLaunchOptions,
  ...i18n,
};
